import {AuthProviderProps} from "react-oidc-context";
import {signinRedirectUri} from "./service/oidcCallbackUrl";

export const isProduction = process.env.NODE_ENV === "production";

declare global {
  interface Window {
    // Écrit au démarrage du conteneur dans /config.js, chargé par index.html avant le bundle.
    __ENV__?: Readonly<Record<string, string>>;
  }
}

// En production, les valeurs viennent de window.__ENV__, écrit au démarrage du conteneur par
// docker/prod/entrypoint.sh. Chaque clé passée à getEnv y est requise : le Dockerfile extrait
// d'ici la liste des getEnv("REACT_APP_…"), et le conteneur refuse de démarrer s'il en manque une.
// Garder donc un littéral par appel. En développement, Vite fournit import.meta.env.
const getEnv = (key: string): string => {
  return (isProduction ? window.__ENV__?.[key] : import.meta.env[key]) ?? "";
};

export const REACT_APP_KEYCLOAK_URL = getEnv("REACT_APP_KEYCLOAK_URL");
// Développement seulement : en production, PrivateRoutes court-circuite cette valeur par
// `isProduction ||`. Elle y est donc sans effet, et reste hors de getEnv pour ne pas être exigée
// du conteneur.
export const REACT_APP_USE_KEYCLOAK_IN_DEV = isProduction ? "" : (import.meta.env.REACT_APP_USE_KEYCLOAK_IN_DEV ?? "");
export const REACT_APP_API_CONTROL_URL = getEnv("REACT_APP_API_CONTROL_URL");
export const REACT_APP_API_ENEDIS_URL = getEnv("REACT_APP_API_ENEDIS_URL");
export const REACT_APP_API_SIZEA_URL = getEnv("REACT_APP_API_SIZEA_URL");
export const REACT_APP_API_PRESALES_URL = getEnv("REACT_APP_API_PRESALES_URL");
export const REACT_APP_API_V2_URL = getEnv("REACT_APP_API_V2_URL");
export const REACT_APP_API_TRACE_URL = getEnv("REACT_APP_API_TRACE_URL");
export const REACT_APP_MERCURE_URL = getEnv("REACT_APP_MERCURE_URL");
export const REACT_APP_KEYCLOAK_REALM = getEnv("REACT_APP_KEYCLOAK_REALM");
export const REACT_APP_KEYCLOAK_CLIENT_ID = getEnv("REACT_APP_KEYCLOAK_CLIENT_ID");
export const REACT_APP_GOOGLE_MAP_KEY = getEnv("REACT_APP_GOOGLE_MAP_KEY");
export const REACT_APP_APP_CLIENT_URL = getEnv("REACT_APP_APP_CLIENT_URL");
export const REACT_APP_GRAFANA_URL = getEnv("REACT_APP_GRAFANA_URL");
export const REACT_APP_APP_CLIENT_LUMIOO_URL = getEnv("REACT_APP_APP_CLIENT_LUMIOO_URL");
export const REACT_APP_MAPBOX_TOKEN = getEnv("REACT_APP_MAPBOX_TOKEN");
export const REACT_APP_DIRECTUS_URL = getEnv("REACT_APP_DIRECTUS_URL");
export const REACT_APP_API_IMPLANTATION_URL = getEnv("REACT_APP_API_IMPLANTATION_URL");
export const REACT_APP_ALARMS_TO_HIDE_IN_SCADA_PLANTS_VIEW = getEnv("REACT_APP_ALARMS_TO_HIDE_IN_SCADA_PLANTS_VIEW");
export const REACT_APP_ENABLE_TARIFF_OPTIMIZATION = getEnv("REACT_APP_ENABLE_TARIFF_OPTIMIZATION");
export const REACT_APP_API_EMS_URL = getEnv("REACT_APP_API_EMS_URL");
export const REACT_APP_API_JFROG_URL = getEnv("REACT_APP_API_JFROG_URL");
export const REACT_APP_ECONOMICAL_PRICES_HELP_URL = getEnv("REACT_APP_ECONOMICAL_PRICES_HELP_URL");
export const REACT_APP_ENABLE_CONCRETE_VIEW = getEnv("REACT_APP_ENABLE_CONCRETE_VIEW");

export const oidcConfig: AuthProviderProps = {
  authority: REACT_APP_KEYCLOAK_URL + "/realms/" + REACT_APP_KEYCLOAK_REALM,
  client_id: REACT_APP_KEYCLOAK_CLIENT_ID,
  // Valeur par défaut seulement, figée au chargement sur la page d'arrivée. Les connexions lancées
  // en cours de navigation (`PrivateRoutes`, échec du renouvellement dans `Menu`) passent le leur,
  // calculé sur la page affichée : sans ça, l'utilisateur reviendrait sur la page d'arrivée.
  // L'échange du code en cours n'en dépend pas : il utilise le `redirect_uri` mémorisé avec l'état.
  redirect_uri: signinRedirectUri(window.location.href),
  // `onSigninCallback` est fourni par `App`, qui a besoin du routeur pour nettoyer l'URL.
  post_logout_redirect_uri: window.location.origin,
  scope: "openid profile email roles",
};
